module.exports = __webpack_public_path__ + "img/greenfish.a274ccbd.png";